import React from 'react';
import { Gift, Lightbulb, ClipboardList, FileText, DollarSign, Briefcase, BookOpen } from 'lucide-react';
import { SectionReveal, StaggerContainer, StaggerItem } from './SectionReveal';
export function BonusesSection() {
  const bonuses = [{
    num: '01',
    title: 'Guía Visual de Luces del Tablero',
    icon: <Lightbulb className="w-6 h-6 text-[#F59E0B]" data-id="element-27" />
  }, {
    num: '02',
    title: 'Checklist Previaje Imprimible',
    icon: <ClipboardList className="w-6 h-6 text-[#F59E0B]" data-id="element-28" />
  }, {
    num: '03',
    title: 'Plantillas Para Pedir Presupuestos',
    icon: <FileText className="w-6 h-6 text-[#F59E0B]" data-id="element-29" />
  }, {
    num: '04',
    title: 'Guía de Costos de Reparaciones Comunes',
    icon: <DollarSign className="w-6 h-6 text-[#F59E0B]" data-id="element-30" />
  }, {
    num: '05',
    title: 'Kit de Emergencias del Automóvil',
    icon: <Briefcase className="w-6 h-6 text-[#F59E0B]" data-id="element-31" />
  }, {
    num: '06',
    title: 'Manual Express Para Comprar Autos Usados',
    icon: <BookOpen className="w-6 h-6 text-[#F59E0B]" data-id="element-32" />
  }];
  return <section className="py-20 md:py-32 bg-[#0a0a0a] border-b border-[#262626]" data-id="element-33">
      <div className="max-w-6xl mx-auto px-4 md:px-6" data-id="element-34">
        <SectionReveal className="text-center mb-16" data-id="element-35">
          <div className="inline-flex items-center gap-2 border border-[#F59E0B]/30 bg-[#F59E0B]/10 text-[#F59E0B] font-heading text-sm tracking-[0.2em] px-4 py-1.5 rounded-sm mb-6" data-id="element-36">
            <Gift className="w-4 h-4" data-id="element-37" /> INCLUIDO SIN COSTO ADICIONAL
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-white" data-id="element-38">
            Además recibís estos 6 Bonos Exclusivos
          </h2>
        </SectionReveal>

        <StaggerContainer className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6" data-id="element-39">
          {bonuses.map((bono, idx) => <StaggerItem key={idx} className="bg-[#171717] border border-[#262626] p-6 rounded-sm flex items-start gap-4 hover:border-[#F59E0B]/50 transition-colors" data-id="element-40">
              <div className="p-3 bg-[#0a0a0a] rounded-sm border border-[#262626] shrink-0" data-id="element-41">
                {bono.icon}
              </div>
              <div data-id="element-42">
                <div className="text-[#F59E0B] font-heading text-sm font-bold tracking-widest mb-1" data-id="element-43">
                  🎁 BONO {bono.num}
                </div>
                <h3 className="text-white font-medium leading-snug" data-id="element-44">
                  {bono.title}
                </h3>
              </div>
            </StaggerItem>)}
        </StaggerContainer>
      </div>
    </section>;
}